enum OrdersRoutesEnum {
  'ORDERS' = '/orders',
  'HISTORY' = 'history',
  'UPCOMING' = 'upcoming',
  'TRACKER' = 'tracker',
}

export default OrdersRoutesEnum
